import { TicketType } from '../../constants/tickets';
import { Ticket } from '../../types/ticket';
import { Rule } from '../types/Rule';
import { RuleContext } from '../types/RuleContext';

const { CHECKIN_MEMBER, FAN_MEMBER, HALF_ENTRY } = TicketType;

export class RemoveHalfTicketsRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { membership, tickets } = context;
    if (!membership?.name.startsWith('ESQUADRAONAFONTE') || !this.haveBenefitTicketType(tickets)) {
      return tickets;
    }

    return tickets.map((item) => {
      item.type = item.type.filter((ticket) => Number(ticket.category.id) !== HALF_ENTRY);
      return item;
    });
  }

  private haveBenefitTicketType(tickets: Ticket[]) {
    return tickets.some(ticket =>
      ticket.salable &&
      ticket.type.some(({ category, status }) =>
        ([CHECKIN_MEMBER, FAN_MEMBER] as number[]).includes(Number(category.id)) && status === 'available'
      )
    );
  }
}
